import React from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import FieldForm from '../Forms/FieldForm';

const AddEditFieldModal = ({
	dataField,
	isOpen,
	isEdit,
	handleToggleModal,
	resultHandler,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='lg'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Field
			</ModalHeader>

			<FieldForm
				dataField={dataField}
				isOpen={isOpen}
				isEdit={false}
				handleToggleModal={handleToggleModal}
				resultHandler={resultHandler}
			/>
		</Modal>
	);
};

export default AddEditFieldModal;
